import { render, staticRenderFns } from "./ListTradeComponent.vue?vue&type=template&id=4ff7f1d6&scoped=true&"
import script from "./ListTradeComponent.vue?vue&type=script&lang=js&"
export * from "./ListTradeComponent.vue?vue&type=script&lang=js&"
import style0 from "./ListTradeComponent.vue?vue&type=style&index=0&id=4ff7f1d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff7f1d6",
  null
  
)

export default component.exports